export const expense_category_data = [
  {
    key: '1',
    id: 'EXC617453',
    category: 'Utilities',
    description: 'Expenses related to electricity, water, and gas',
  },
  {
    key: '2',
    id: 'EXC617452',
    category: 'Salaries',
    description: 'Monthly payment for teaching and non-teaching staff',
  },
  {
    key: '3',
    id: 'EXC617451',
    category: 'Maintenance',
    description: 'Costs for maintaining and repairing school property',
  },
  {
    key: '4',
    id: 'EXC617450',
    category: 'Transportation',
    description: 'Expenses for school transportation services',
  },
  {
    key: '5',
    id: 'EXC617449',
    category: 'Sports',
    description: 'Expenses for sports equipment and team uniforms',
  },
  {
    key: '6',
    id: 'EXC617448',
    category: 'Office Supplies',
    description: 'Regular purchases of stationery and office supplies',
  },
  {
    key: '7',
    id: 'EXC617447',
    category: 'Equipment',
    description: 'Purchase of educational and administrative equipment',
  },
  {
    key: '8',
    id: 'EXC617446',
    category: 'Technology',
    description: 'Investment in software, hardware, and IT support',
  },
  {
    key: '9',
    id: 'EXC617445',
    category: 'Events',
    description: 'Costs associated with organizing school events',
  },
  {
    key: '10',
    id: 'EXC617444',
    category: 'Food Services',
    description: 'Expenses for cafeteria services and food supplies',
  }
];
